// Import CSS for Rollup to process
import '../css/index.css';
import { initWebBundles } from './web-bundles.js';

// Scroll-triggered fade-in animations
document.addEventListener('DOMContentLoaded', () => {
    initWebBundles().catch((err) => console.error('initWebBundles failed:', err));

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));

    // Mobile nav toggle
    const burger = document.querySelector('[data-nav-toggle]');
    const mobileNav = document.querySelector('[data-mobile-nav]');
    if (burger && mobileNav) {
        burger.addEventListener('click', () => {
            const isOpen = mobileNav.classList.toggle('hidden');
            burger.setAttribute('aria-expanded', !isOpen);
        });
    }
});

// Podcast audio player
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.bmad-player').forEach((p) => {
        const audio = p.querySelector('audio');
        if (!audio || !p.dataset.audio) return;
        audio.src = p.dataset.audio;
        const pp = p.querySelector('[data-pp]');
        const iPlay = p.querySelector('[data-icon-play]');
        const iPause = p.querySelector('[data-icon-pause]');
        const cur = p.querySelector('[data-cur]');
        const dur = p.querySelector('[data-dur]');
        const track = p.querySelector('[data-track]');
        const fill = p.querySelector('[data-fill]');
        const buffer = p.querySelector('[data-buffer]');
        const fmt = (s) => {
            s = Math.max(0, Math.floor(s || 0));
            const ss = String(s % 60).padStart(2, '0');
            const m = Math.floor(s / 60);
            const h = Math.floor(m / 60);
            return h > 0 ? `${h}:${String(m % 60).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
        };
        pp.addEventListener('click', () => { audio.paused ? audio.play() : audio.pause(); });
        audio.addEventListener('play', () => { iPlay.hidden = true; iPause.hidden = false; pp.setAttribute('aria-label', 'Pause episode'); });
        audio.addEventListener('pause', () => { iPlay.hidden = false; iPause.hidden = true; pp.setAttribute('aria-label', 'Play episode'); });
        audio.addEventListener('loadedmetadata', () => { dur.textContent = fmt(audio.duration); });
        audio.addEventListener('timeupdate', () => {
            const pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
            fill.style.width = pct + '%';
            cur.textContent = fmt(audio.currentTime);
        });
        audio.addEventListener('progress', () => {
            try { if (audio.buffered.length && audio.duration) buffer.style.width = (audio.buffered.end(audio.buffered.length - 1) / audio.duration * 100) + '%'; } catch (e) {}
        });
        track.addEventListener('click', (e) => {
            const r = track.getBoundingClientRect();
            if (audio.duration) audio.currentTime = ((e.clientX - r.left) / r.width) * audio.duration;
        });
        p.querySelectorAll('[data-skip]').forEach((b) => b.addEventListener('click', () => {
            audio.currentTime = Math.max(0, Math.min(audio.duration || 0, audio.currentTime + parseInt(b.dataset.skip, 10)));
        }));
    });
});
